import { render, staticRenderFns } from "./NextConsultations.vue?vue&type=template&id=02a68601"
import script from "./NextConsultations.vue?vue&type=script&lang=js"
export * from "./NextConsultations.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports